import { Dialog, List, ListItemButton, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecordingControl } from 'features/toolbar/toolbar/controls/recording/useRecordingControl';
import { useAppDispatch } from 'store/hooks';
import { openModal } from 'features/modal/modalSlice';

export type RecordingOptionsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const RecordingOptionsDialog = ({ onClose, open }: RecordingOptionsDialogProps) => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();
  const { toggleRecording } = useRecordingControl();

  const handleAddBookmark = () => {
    onClose();
    dispatch(openModal('addBookmarkModal'));
  };

  const handleStopRecording = () => {
    onClose();
    toggleRecording();
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <List>
        <ListItemButton autoFocus onClick={handleAddBookmark}>
          <ListItemText primary={t('toolbar.recording.menu_options.add_bookmark')} />
        </ListItemButton>
        <ListItemButton onClick={handleStopRecording}>
          <ListItemText primary={t('toolbar.recording.menu_options.stop_recording')} />
        </ListItemButton>
      </List>
    </Dialog>
  );
};

export default RecordingOptionsDialog;
